import {
  BriefcaseIcon,
  CreditCardIcon,
  CpuIcon,
  TerminalIcon,
  PackageIcon,
  CloudIcon,
} from '@primer/octicons-react';
import { Box, Text, Heading, useTheme } from '@primer/react';
import Reveal from './Reveal';

const industries = [
  { label: 'Enterprise', icon: BriefcaseIcon },
  { label: 'FinTech', icon: CreditCardIcon },
  { label: 'AI & ML', icon: CpuIcon },
  { label: 'Developer Experience', icon: TerminalIcon },
  { label: 'Logistics', icon: PackageIcon },
  { label: 'SaaS', icon: CloudIcon },
];

function Industries() {
  const { colorMode } = useTheme();
  const isDark = colorMode === 'night';

  return (
    <Box
      sx={{
        backgroundColor: isDark ? '#0d1117' : '#f0f2f5',
        paddingX: ['24px', '48px', '100px'],
        paddingY: [7, 8, 9],
      }}
    >
      <Box sx={{ maxWidth: '1400px', margin: '0 auto', textAlign: 'center' }}>
        <Reveal>
          <Text
            as="p"
            sx={{
              margin: 0,
              marginBottom: 2,
              fontSize: 1,
              fontWeight: 600,
              letterSpacing: '0.2em',
              textTransform: 'uppercase',
              color: isDark ? 'rgba(255, 255, 255, 0.5)' : 'rgba(27, 31, 36, 0.55)',
            }}
          >
            Industries We Serve
          </Text>
          <Heading
            as="h2"
            sx={{
              margin: '0 auto',
              marginBottom: [6, 7, 8],
              maxWidth: '700px',
              fontFamily: "'Fraunces', serif",
              fontWeight: 300,
              fontSize: ['2rem', '2.75rem', '3.25rem'],
              lineHeight: 1.25,
              color: isDark ? '#f5f1ea' : '#1b1f24',
            }}
          >
            UX for the industries driving digital transformation.
          </Heading>
        </Reveal>

        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: 3,
          }}
        >
          {industries.map((industry, index) => {
            const Icon = industry.icon;
            return (
              <Reveal key={industry.label} delay={index * 0.06}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    paddingX: 4,
                    paddingY: 3,
                    borderRadius: '999px',
                    border: isDark ? '1px solid rgba(255, 255, 255, 0.12)' : '1px solid rgba(27, 31, 36, 0.12)',
                    backgroundColor: isDark ? 'rgba(255, 255, 255, 0.03)' : 'rgba(255, 255, 255, 0.7)',
                  }}
                >
                  <Icon size={16} fill="#8ec5ff" />
                  <Text sx={{ fontSize: 1, color: isDark ? '#f5f1ea' : '#1b1f24', whiteSpace: 'nowrap' }}>
                    {industry.label}
                  </Text>
                </Box>
              </Reveal>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
}

export default Industries;
